// @flow
export const getStripeErrorMessageFromResponse = (payload: any) => {
    if (payload?.response?.body?.result?.content) {
        return payload.response.body.result.content;
    } else if (payload?.message) {
        return payload.message;
    } else {
        return 'Error Making the request';
    }
};
